<div class="container-fluid mt-3 g-0 pe-3">
    @if (Intervention) {
    <div class="row">
        @if (Intervention) {
        <span class="text-center">Contact chantier
            <span class="fw-bold">{{Intervention.Contact.FirstName}} {{Intervention.Contact.LastName}}</span><br />
            <span class="fw-bold">{{Intervention.Contact.Phone}} </span>
        </span>
        }
    </div>
    <div class="row justify-content-center">
        <button class="col-auto" color="primary" mat-icon-button (click)="openDispatchComment()"
            [disabled]="this.Intervention.Comment === null || this.Intervention.Comment === ''">
            <mat-icon class="material-symbols-outlined">comment</mat-icon>
        </button>
    </div>

    @for (zp of ZoneProcessList; track zp; let i = $index) {
    <div class="col-12 col-md-4 col-xl-2 m-1 ">
        <div class="h-100 m-3">
            <div class="row border rounded-1 background-light" [style.border-left-color]="getColorByInterventionIndex(zp)" style="
                                                                                                        border-width: 2px !important;
                                                                                                        border-left: 20px solid !important;">
                <!-- <div class="" [style.border-color]="getColorByInterventionIndex(zp)" style="max-width: 14px !important;
                                                                                            display: inline-flex;
                                                                                            border: 2px solid;
                                                                                            padding: 0;
                                                                                            border-radius: 2px;">
            <span style="min-width: 10px;" [style.background-color]="getColorByInterventionIndex(zp)"></span>
          </div> -->
                <!-- ZONE BELOW -->
                @if (IsZone(zp)) {
                <div class="col ms-1 p-2">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="col-3">
                                    @if ($any(zp).IsDepose) {
                                    <img src="assets/DEPOSE.png" width="50" height="50" />
                                    }
                                    @if (!$any(zp).IsDepose) {
                                    <img src="assets/POSE.png" width="50" height="50" />
                                    }
                                </div>
                                <div class="col text-center">
                                    <h2 class="fw-bold"> Zone {{zp.Name}}</h2>
                                    <span class=""> {{zp.CustomerReference}}</span>
                                </div>
                                <div class="col-auto text-end">
                                    <button class="" [color]="hasCompletedZoneConformite($any(zp)) ? 'primary' : 'accent'" mat-icon-button
                                        (click)="openZoneConformiteDialog($any(zp))">
                                        <mat-icon class="material-symbols-outlined">inventory</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- <button class="col-auto" color="primary" mat-icon-button (click)="openZoneConformiteDialog($any(zp))">
                <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
              </button> -->
                    </div>
                    <div class="row mt-3">
                        <div class="col-auto fst-italic">
                            Liste des matériaux
                        </div>
                    </div>
                    @for (mpca of $any(zp).MpcaList; track mpca) {
                    <span class="row text-start">
                        <div class="ms-3 my-auto col-auto">
                            <mat-icon class="material-symbols-outlined">type_specimen</mat-icon>
                        </div>
                        <span class="col"> {{mpca.Name}} / {{mpca.ScolaMaterial}} {{getDegradationLevelName(mpca.DegradationLevel)}}</span>
                    </span>
                    }
                    <span class="row justify-content-center mb-3">
                        <button class="ms-3 col-auto ps-3" color="primary" mat-raised-button (click)="addNewMPCA($any(zp))">
                            <mat-icon class="material-symbols-outlined">add</mat-icon> Nouveau MPCA
                        </button>
                    </span>
                    <div class="row justify-content-around">
                        @if ($any(zp).IsDepose) {
                        <span class="col-10 mb-2">
                            <button class="w-100" color="primary" mat-raised-button (click)="searchPompe()">
                                <mat-icon class="material-symbols-outlined">search</mat-icon> Recherche de pompe
                            </button>
                        </span>
                        }
                        @for (m of $any(zp).ZoneMesureList; track m) {
                        <span class="col-11 text-center border rounded-1 m-1 p-3" [style.background]="m.Color">
                            <div class="row justify-content-center align-items-center align-content-center" [class.backgroundhatched]="m.IsCancelled">
                                <!-- <span *ngIf="!m.IsCancelled"> -->
                                <div class="col-2"></div>
                                <div class="fs-5 fw-bold col" [style.color]="m.TextColor" (click)="navigateToZoneMeasure($any(zp), m.Code, m.IsDepose)">
                                    {{m.MeasureReferenceName}}
                                </div>
                                <div class="col-2">
                                    @if (IsDone(m)) {
                                    <mat-icon class="material-symbols-outlined" style="height: 30px; width: 30px; font-size: 30px;">done</mat-icon>
                                    }
                                </div>
                                <!-- </span> -->
                                <!-- <div *ngIf="m.IsCancelled" class="col-12">
                  <div class="fs-5 fw-bold backgroundhatched" [style.color]="m.TextColor">
                    {{m.MeasureReferenceName}}
                  </div>
                </div> -->
                                @if (m.PumpWithBattery) {
                                <span class="">
                                    <mat-icon class="material-symbols-outlined"> battery_charging_full </mat-icon>
                                </span>
                                }
                            </div>
                        </span>
                        }
                    </div>
                    @for (a of $any(zp).AreaMapList; track a) {
                    <div class="row mt-3 g-1 text-center" (click)="navigateToDrawingMapTool(a.Id, $any(zp))">
                        <span class="col-12 p-3 border rounded-1 background-200">
                            <!-- <div class="col-auto">
              <mat-icon class="material-symbols-outlined"> map </mat-icon>
            </div> -->
                            <span class="col-auto display-3 fw-bolder text-with-border">{{a.Legend}}</span>
                        </span>
                    </div>
                    }
                </div>
                }
                <!-- PROCESS BELOW -->
                @if (!IsZone(zp)) {
                <div class="col ms-1 p-2">
                    <div class="row">
                        <div class="col">
                            <div class="row align-items-center">
                                <h2 class="col text-center fw-bold m-0"> {{zp.Name}}</h2>
                                <div class="col-auto">
                                    <button class="ms-3 col-auto ps-3" [color]="hasCompletedProcessConformite($any(zp)) ? 'primary' : 'accent'" mat-icon-button
                                        (click)="openProcessConformiteDialog($any(zp))">
                                        <mat-icon class="material-symbols-outlined">inventory</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <span class="col text-center"> ({{zp.CustomerReference}})</span>
                            </div>
                        </div>
                        <!-- <button class="col-auto" color="primary" mat-icon-button (click)="openProcessConformiteDialog($any(zp))">
        <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
      </button> -->
                    </div>
                    <div class="row mt-3">
                        <div class="col-auto fst-italic">
                            Liste des matériaux
                        </div>
                    </div>
                    @for (pt of $any(zp).ProcessTechniqueList; track pt) {
                    <div class="row text-start">
                        <div class="ms-3 my-auto col-auto">
                            <mat-icon class="material-symbols-outlined">type_specimen</mat-icon>
                        </div>
                        <span class="col"> {{pt.Mpca?.Name}} / {{pt.Mpca?.ScolaMaterial}} {{getDegradationLevelName($safeNavigationMigration(pt.Mpca?.DegradationLevel))}}</span>
                    </div>
                    }
                    <div class="row justify-content-center">
                        <span class="col-10 border rounded-1 p-1 m-2" [style.background]="$any(zp).ProcessMesure.Color">
                            <div class="row justify-content-center">
                                @if (!$any(zp).ProcessMesure.IsCancelled) {
                                <span class="col-12">
                                    <div class="fs-5 fw-bold text-center" [style.color]="$any(zp).ProcessMesure.TextColor"
                                        (click)="navigateToProcessMeasure($any(zp), $any(zp).ProcessMesure.Code, $any(zp).ProcessCalculation.SamplingMode)">
                                        {{$any(zp).ProcessMesure.MeasureReferenceName}}</div>
                                </span>
                                }
                                @if ($any(zp).ProcessMesure.IsCancelled) {
                                <span class="col-12">
                                    <div class="fs-5 fw-bold backgroundhatched" [style.color]="$any(zp).ProcessMesure.TextColor">
                                        {{$any(zp).ProcessMesure.MeasureReferenceName}}</div>
                                </span>
                                }
                                <div class="row justify-content-center">
                                    <span class="col-auto">
                                        <div class="row g-0">
                                            <span class="my-auto col-auto">{{$any(zp).ProcessMesure.OperatorsCount}}</span>
                                            <span class="col-auto">
                                                <mat-icon class="material-symbols-outlined"> person </mat-icon>
                                            </span>
                                        </div>
                                    </span>
                                    <span class="col-auto">
                                        <div class="row g-0">
                                            <span class="my-auto col-auto">{{$any(zp).ProcessMesure.BatteryCount}}</span>
                                            <span class="col-auto">
                                                <mat-icon class="material-symbols-outlined"> battery_charging_full </mat-icon>
                                            </span>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </span>
                    </div>
                    @if ($any(zp).AreaMap) {
                    <div class="row text-center mt-3 g-1" (click)="navigateToDrawingMapTool($any(zp).AreaMap.Id, $any(zp).ProcessMesure)">
                        <span class="col-12 p-3 border rounded-1 background-200">
                            <!-- <div class="col-auto">
          <mat-icon class="material-symbols-outlined"> map </mat-icon>
        </div> -->
                            <span class="col-auto display-3 fw-bolder text-with-border">{{$any(zp).AreaMap.Legend}}</span>
                        </span>
                    </div>
                    }
                </div>
                }
            </div>
        </div>
    </div>
    }

    <div class="row px-3">
        @for (mL of MeasureAdductionList; track mL) {
        <div class="col-3 p-0">
            <div class="m-1 p-1 border rounded-1 background-light" [class.backgroundhatched]="mL.IsCancelled" (click)="!mL.IsCancelled ? navigateToMesureAdduction(mL.Code) : ''">
                <div class="my-auto col text-center">
                    <mat-icon class="material-symbols-outlined">air</mat-icon>
                </div>
                <div class="text-center">
                    {{mL.Position}}
                </div>
            </div>
        </div>
        }
        @for (mL of MeasureMassifList; track mL) {
        <div class="col-3 p-0">
            <div class="m-1 p-1 border rounded-1 background-light" [class.backgroundhatched]="mL.IsCancelled" (click)="!mL.IsCancelled ? navigateToMassifMeasure(mL.Code) : ''">
                <div class="my-auto col text-center">
                    <mat-icon class="material-symbols-outlined">biotech</mat-icon>
                </div>
                <div class="text-center">
                    {{mL.Position}}
                </div>
            </div>
        </div>
        }
        @for (mL of MeasureEauList; track mL) {
        <div class="col-3 p-0">
            <div class="m-1 p-1 border rounded-1 background-light" [class.backgroundhatched]="mL.IsCancelled" (click)="!mL.IsCancelled ? navigateToEauMeasure(mL.Code): ''">
                <div class="my-auto col text-center">
                    <mat-icon class="material-symbols-outlined">water</mat-icon>
                </div>
                <div class="text-center">
                    {{mL.Position}}
                </div>
            </div>
        </div>
        }
        @for (mL of MeasureLingetteList; track mL) {
        <div class="col-3 p-0">
            <div class="m-1 p-1 border rounded-1 background-light" [class.backgroundhatched]="mL.IsCancelled" [style.background-color]="getColorByLingetteStatus(mL)"
                (click)="!mL.IsCancelled ? navigateToLingetteMeasure(mL.Code): ''">
                <div class=" my-auto col text-center">
                    <mat-icon class="material-symbols-outlined">wash</mat-icon>
                </div>
                <div class="text-center">
                    {{mL.Position}}
                </div>
            </div>
        </div>
        }
        @for (mL of MeasureGenericList; track mL) {
        <div class="col-6 col-sm-4 col-xl-2 p-0">
            <div class="m-1 p-1 border rounded-1 background-light" [class.backgroundhatched]="mL.IsCancelled" (click)="!mL.IsCancelled ? navigateToGeneric(mL.Code): ''">
                <div class=" my-auto col text-center">
                    <mat-icon class="material-symbols-outlined">view_in_ar</mat-icon>
                </div>
                <div class="text-center">
                    {{mL.GroupName}} {{mL.Name}}
                </div>
            </div>
        </div>
        }
        @for (map of Intervention.LingetteAreaMapTerrainList; track map) {

        <div class="row text-center mt-3 g-1" (click)="navigateToDrawingMapTool($any(map).Id, $any(map).ProcessMesure)">
            <span class="col-12 p-3 border rounded-1 background-200">

                <span class="col-auto display-3 fw-bolder text-with-border">{{$any(map).Legend}}</span>
            </span>
        </div>
        }
        @for (map of Intervention.MassifAreaMapTerrainList; track map) {

        <div class="row text-center mt-3 g-1" (click)="navigateToDrawingMapTool($any(map).Id, $any(map).ProcessMesure)">
            <span class="col-12 p-3 border rounded-1 background-200">

                <span class="col-auto display-3 fw-bolder text-with-border">{{$any(map).Legend}}</span>
            </span>
        </div>
        }
    </div>
    }
</div>